import { render, staticRenderFns } from "./CourseJuniorClassesSubsection.vue?vue&type=template&id=288107de&scoped=true"
import script from "./CourseJuniorClassesSubsection.vue?vue&type=script&lang=js"
export * from "./CourseJuniorClassesSubsection.vue?vue&type=script&lang=js"
import style0 from "./CourseJuniorClassesSubsection.vue?vue&type=style&index=0&id=288107de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288107de",
  null
  
)

export default component.exports